import CollateralInfoTab from './CollateralInfoTab.vue';

export default CollateralInfoTab;
